var GoogleClassroomSync = {
	beginSync: function(finalCallback, updateMessageCallback) {
		var teacherData = {};
		var teacherCourses = [];

		function requestAuth() {
			var clientID = "685312089971-sq3b4ov7s8e1c8774hakb0tq5i8v9l6q.apps.googleusercontent.com";
			var scopes = ['https://www.googleapis.com/auth/classroom.courses.readonly',
				'https://www.googleapis.com/auth/classroom.rosters.readonly',
				"email", "profile",
				'https://www.googleapis.com/auth/userinfo.profile']

			gapi.auth.authorize(
				{ client_id: clientID, scope: scopes, immediate: false, authuser: -1 },

				function(authResult) {
					if (authResult && !authResult.error) {
						updateMessageCallback("Fetching account...");
						getTeacherData();
					} else {
						console.log("Error 1");
						finalCallback(false, null, null, "Error loading google account");
					}
				}
			);
		}

		function getTeacherData() {
			var request = gapi.client.request({
				root: 'https://www.googleapis.com',
				path: 'oauth2/v1/userinfo?alt=json',
			});

			request.execute(function(response) {
				teacherData = {
					first_name: response.given_name,
					last_name: response.family_name,
					sign_in_email: response.email,
					google_sso_id: response.id
				}

				updateMessageCallback("Fetching courses...");
				getCourses();
			});
		}

		function getCourses() {
			var request = gapi.client.request({
				root: 'https://classroom.googleapis.com',
				path: 'v1/courses',
			});

			request.execute(function(response) {
				var courses = response.courses;
				if (typeof courses != 'undefined') {
					if (courses.length > 0) {
						var ownerIDs = [];

						for (var i = 0; i < courses.length; i++) {
							if (courses[i].courseState == "ACTIVE") {
								teacherCourses = teacherCourses.concat([{
									name: courses[i].name,
									google_id: courses[i].id,
									students: []
								}]);
								ownerIDs.push(courses[i].ownerId);
							}
						}

						if (_.includes(ownerIDs, teacherData.google_sso_id)) {
							getStudents(0, null);
						} else {
							console.log("Error 6");
							finalCallback(false, null, null, "You can only sign up with a teacher's Google account.");
						}

					} else {
						console.log("Error 4");
						finalCallback(false, null, null, "You don't have any courses on Google Classroom.");
					}
				} else {
					console.log("Error 5")
					finalCallback(false, null, null, "We were not able to retrieve your Google Classroom data. Did you use the right Google account?");
				}
			});
		}

		// Should be called once, in order, for every course in teacherCourses
		function getStudents(courseIndex, pageToken) {
			var course = teacherCourses[courseIndex];

			if (course) {
				var request = gapi.client.request({
					root: 'https://classroom.googleapis.com',
					path: 'v1/courses/' + course.google_id + '/students',
					params: {
						pageToken: pageToken
					}
				});

				updateMessageCallback("Fetching students (" + (courseIndex + 1) + ")...");

				request.execute(function(response) {
					if (response.students && response.students.length > 0) {
						course["students"] = course["students"].concat(response.students.map((student) => {
							return {
								first_name: student.profile.name.givenName,
								last_name: student.profile.name.familyName,
								google_sign_in_id: student.profile.id
							}
						}));

					} else {
						course["students"] = [];
						console.log("No students!");
					}

					if (response.nextPageToken) {
						getStudents(courseIndex, response.nextPageToken);						
					} else {
						getStudents(courseIndex + 1, null);
					}

				}.bind(this));
			} else {
				finalCallback(true, teacherData, teacherCourses);
			}
		}

		requestAuth();
	}
}

module.exports = GoogleClassroomSync;


// WEBPACK FOOTER //
// ./modules/lib/integrations/GoogleClassroomSync.js